import OpenAIIcon from "../Icons/OpenAIIcon";
import GoogleGeminiIcon from "../Icons/GoogleGeminiIcon";
import ClaudeIcon from "../Icons/ClaudeIcon";
import LlamaIcon from "../Icons/LlamaIcon";
import MoonshotAIIcon from "../Icons/MoonshotAIIcon";
import DeepSeekIcon from "../Icons/DeepseekIcon";
import GrokIcon from "../Icons/GrokIcon";
import NvidiaIcon from "../Icons/NvidiaIcon";
// AWS Bedrock + Qwen model options (added — see gptModels.ts Bedrock/Qwen/Jarvis Labs sections below)
import GoogleIcon from "../Icons/GoogleIcon";
import ZaiIcon from "../Icons/ZaiIcon";
import QwenIcon from "../Icons/QwenIcon";

const oldModels = {
  "gemini-1.5-flash": "Gemini 1.5 Flash",
  "gemini-2.5-flash-lite-preview-06-17": "Gemini 2.5 Flash Lite",
  "baseten/meta-llama/Llama-4-Scout-17B-16E-Instruct": "Llama 4 Scout",
  "baseten/meta-llama/Llama-4-Maverick-17B-128E-Instruct": "Llama 4 Maverick",
  "baseten/moonshotai/Kimi-K2-Instruct": "Kimi K2",
  "gemini-2.5-pro": "Gemini 2.5 Pro",
  "gemini-2.5-flash": "Gemini-2.5-Flash",
  // "gemini-2.5-flash-lite": "Gemini 2.5 Flash Lite",
  "groq/meta-llama/llama-4-maverick-17b-128e-instruct": "Llama 4 Maverick",
  "gemini-flash-lite-latest": "Gemini 2.5 Flash Lite",
  "gemini-flash-latest": "Gemini 3 Flash",
  "superdash-llama-4-maverick": "Llama 4 Maverick",
  "baseten/deepseek-ai/DeepSeek-V3-0324": "DeepSeek V3 0324",
  "gemini-3.1-flash-lite-preview": "Gemini 3.1 Flash Lite",
  "grok-4-1-fast-non-reasoning-latest": "Grok 4.1 Fast",
};

const modelIcons = {
  "gpt-4.1-nano": OpenAIIcon,
  "gemini-2.0-flash-lite": GoogleGeminiIcon,
  "gemini-2.0-flash": GoogleGeminiIcon,
  "gemini-2.5-flash-lite": GoogleGeminiIcon,
  "gemini-3-flash-preview": GoogleGeminiIcon,
  "gemini-3.1-flash-lite": GoogleGeminiIcon,
  "gemini-3.1-flash-lite-preview": GoogleGeminiIcon,
  "gpt-4o-mini": OpenAIIcon,
  "gpt-4.1-mini": OpenAIIcon,
  "gemini-2.5-flash": GoogleGeminiIcon,
  "claude-3-haiku-20240307": ClaudeIcon,
  "claude-3-5-haiku-20241022": ClaudeIcon,
  "claude-4.5-haiku": ClaudeIcon,
  "claude-haiku-4-5-20251001": ClaudeIcon,
  "gpt-4.1": OpenAIIcon,
  "gpt-4o": OpenAIIcon,
  "gpt-5-chat-latest": OpenAIIcon,
  "gpt-5.4-nano": OpenAIIcon,
  "gpt-5.4-mini": OpenAIIcon,
  "gemini-2.5-pro": GoogleGeminiIcon,
  "claude-3-7-sonnet-latest": ClaudeIcon,
  "claude-sonnet-4-20250514": ClaudeIcon,
  "baseten/meta-llama/Llama-4-Maverick-17B-128E-Instruct": LlamaIcon,
  "baseten/meta-llama/Llama-4-Scout-17B-16E-Instruct": LlamaIcon,
  "baseten/moonshotai/Kimi-K2-Instruct": MoonshotAIIcon,
  "baseten/openai/gpt-oss-120b": OpenAIIcon,
  "groq/llama-3.1-8b-instant": LlamaIcon,
  "groq/llama-3.3-70b-versatile": LlamaIcon,
  "groq/meta-llama/llama-4-maverick-17b-128e-instruct": LlamaIcon,
  "groq/meta-llama/llama-4-scout-17b-16e-instruct": LlamaIcon,
  "baseten/moonshotai/Kimi-K2-Instruct-0905": MoonshotAIIcon,
  "baseten/deepseek-ai/DeepSeek-V3-0324": DeepSeekIcon,
  "gemini-flash-lite-latest": GoogleGeminiIcon,
  "gemini-flash-latest": GoogleGeminiIcon,
  "gemini-3-flash": GoogleGeminiIcon,
  "gemini-3.5-flash": GoogleGeminiIcon,
  "superdash-llama-4-maverick": LlamaIcon,
  "grok-4-1-fast-non-reasoning-latest": GrokIcon,
  "grok-4.3": GrokIcon,

  o1: OpenAIIcon,
  "o1-mini": OpenAIIcon,
  "o3-mini": OpenAIIcon,
  "o4-mini": OpenAIIcon,

  "gpt-5-mini": OpenAIIcon,
  "gpt-5-nano": OpenAIIcon,

  "togetherai/meta-llama/Llama-4-Maverick-17B-128E-Instruct-FP8": LlamaIcon,
  "baseten/nvidia/Nemotron-120B-A12B": NvidiaIcon,

  // AWS Bedrock (added alongside Catalyst's existing baseten/* entries — no baseten->bedrock
  // migration/aliasing in this repo, see maskedModels)
  "bedrock/openai.gpt-oss-120b": OpenAIIcon,
  "bedrock/google.gemma-4-e2b": GoogleIcon,
  "bedrock/google.gemma-4-26b-a4b": GoogleIcon,
  "bedrock/google.gemma-4-31b": GoogleIcon,
  "bedrock/google.gemma-3-27b-it": GoogleIcon,
  "bedrock/zai.glm-4.7-flash": ZaiIcon,
  "bedrock/zai.glm-4.7": ZaiIcon,
  "bedrock/zai.glm-5": ZaiIcon,
  "bedrock/moonshotai.kimi-k2.5": MoonshotAIIcon,
  "bedrock/nvidia.nemotron-super-3-120b": NvidiaIcon,
  "bedrock/nvidia.nemotron-nano-3-30b": NvidiaIcon,
  "bedrock/qwen.qwen3-next-80b-a3b-instruct": QwenIcon,

  // Jarvis Labs (India deployed)
  "jarvislabs/gpt-oss-120b": OpenAIIcon,
  "jarvislabs/glm-5.3-flash": ZaiIcon,
  "jarvislabs/glm-5.3": ZaiIcon,
  "jarvislabs/deepseek-v4-flash-0731": DeepSeekIcon,
  "jarvislabs/nemotron-3.5-lightning-30b-a3b-bf16": NvidiaIcon,
  "jarvislabs/gemma-4-26b-a4b-it": GoogleIcon,
  "jarvislabs/gemma-4-31b-it": GoogleIcon,
  "jarvislabs/qwen-3.8-27b-fp8": QwenIcon,
};

const deprecatedModels = {
  "gemini-2.0-flash-lite": "Gemini 2.0 Flash Lite (deprecated)",
  "gemini-2.0-flash": "Gemini 2.0 Flash (deprecated)",
  "togetherai/meta-llama/Llama-4-Maverick-17B-128E-Instruct-FP8":
    "Llama 4 Maverick",
}

const basicModels = {
  // "superdash-35-turbo": "GPT 3.5 Turbo",
  "gpt-4.1-nano": "GPT 4.1 Nano",
  "gpt-5-nano": "GPT 5 Nano",
  "baseten/openai/gpt-oss-120b": "GPT OSS 120B",
  "gemini-2.0-flash-lite": "Gemini 2.0 Flash Lite (deprecated)",
  "gemini-2.0-flash": "Gemini 2.0 Flash (deprecated)",
  // "gemini-flash-lite-latest": "Gemini 2.5 Flash Lite",
  "gemini-2.5-flash-lite": "Gemini 2.5 Flash Lite",
  "groq/llama-3.1-8b-instant": "Llama 3.1 8b Instant",

  // AWS Bedrock (new, additional options — existing baseten entry above is left untouched)
  "bedrock/openai.gpt-oss-120b": "GPT OSS 120B",
  "bedrock/google.gemma-4-e2b": "Gemma 4 E2B (latency optimized)",
  "bedrock/zai.glm-4.7-flash": "GLM 4.7 Flash (latency optimized)",
  "bedrock/nvidia.nemotron-nano-3-30b": "Nemotron Nano 3 30B",
};

const proModels = {
  "gpt-4o-mini": "GPT 4o mini",
  "gpt-4.1-mini": "GPT 4.1 Mini",
  "gpt-5-mini": "GPT 5 Mini",
  "gpt-5.4-nano": "GPT 5.4 Nano",
  // "gemini-flash-latest": "Gemini 3 Flash",
  "gemini-2.5-flash": "Gemini 2.5 Flash",
  "gemini-3-flash-preview": "Gemini 3 Flash",
  "gemini-3.1-flash-lite": "Gemini 3.1 Flash Lite",
  "claude-3-haiku-20240307": "Claude 3 Haiku",
  "groq/llama-3.3-70b-versatile": "Llama 3.3 70b",
  // "superdash-llama-4-maverick": "Llama 4 Maverick",
  "togetherai/meta-llama/Llama-4-Maverick-17B-128E-Instruct-FP8":
    "Llama 4 Maverick (deprecated)",
  "groq/meta-llama/llama-4-scout-17b-16e-instruct": "Llama 4 Scout",
  "baseten/nvidia/Nemotron-120B-A12B": "Nemotron-120B-A12B",
  // "baseten/meta-llama/Llama-4-Scout-17B-16E-Instruct": "Llama 4 Scout",
  // "baseten/meta-llama/Llama-4-Maverick-17B-128E-Instruct": "Llama 4 Maverick",

  // AWS Bedrock (new, additional options — existing baseten entry above is left untouched)
  "bedrock/google.gemma-4-26b-a4b": "Gemma 4 26B (latency optimized)",
  "bedrock/google.gemma-4-31b": "Gemma 4 31B",
  "bedrock/google.gemma-3-27b-it": "Gemma 3 27B",
  "bedrock/nvidia.nemotron-super-3-120b": "Nemotron 3 Super",
  "bedrock/zai.glm-4.7": "GLM 4.7 (latency optimized)",
  "bedrock/qwen.qwen3-next-80b-a3b-instruct": "Qwen3 Next 80B A3B",
};

const premiumModels = {
  "gpt-4.1": "GPT 4.1",
  "gpt-4o": "GPT 4o",
  "gpt-5.4-mini": "GPT 5.4 Mini",
  "gpt-5-chat-latest": "GPT 5 Chat",
  // "gemini-2.5-pro": "Gemini 2.5 Pro",
  "gemini-3.5-flash": "Gemini 3.5 Flash",
  "claude-3-5-haiku-20241022": "Claude 3.5 Haiku",
  "claude-haiku-4-5-20251001": "Claude 4.5 Haiku",
  "claude-3-7-sonnet-latest": "Claude 3.7 Sonnet",
  "claude-sonnet-4-20250514": "Claude 4 Sonnet",
  "grok-4.3": "Grok 4.3",
  "baseten/moonshotai/Kimi-K2-Instruct-0905": "Kimi K2 0905",
  // "baseten/moonshotai/Kimi-K2-Instruct": "Kimi K2"

  // AWS Bedrock (new, additional options)
  "bedrock/zai.glm-5": "GLM 5 (latency optimized)",
  "bedrock/moonshotai.kimi-k2.5": "Kimi K2.5 (latency optimized)",
};

// Jarvis Labs models are served from India. They are kept out of basicModels / proModels /
// premiumModels so they are offered only to assistants whose audio data residency resolves to
// India (see useIsIndiaResidency). Inert in Catalyst today: audioDataResidency doesn't exist
// anywhere here yet, so useIsIndiaResidency always resolves false and these never surface.
const jarvisLabsBasicModels = {
  "jarvislabs/gpt-oss-120b": "GPT OSS 120B (India Deployed)",
  "jarvislabs/glm-5.3-flash": "GLM 5.3 Flash (India Deployed)",
};

const jarvisLabsProModels = {
  "jarvislabs/deepseek-v4-flash-0731": "DeepSeek V4 Flash (India Deployed)",
  "jarvislabs/nemotron-3.5-lightning-30b-a3b-bf16":
    "Nemotron 3.5 Lightning 30B (India Deployed)",
  "jarvislabs/gemma-4-26b-a4b-it": "Gemma 4 26B (India Deployed)",
  "jarvislabs/gemma-4-31b-it": "Gemma 4 31B (India Deployed)",
  "jarvislabs/qwen-3.8-27b-fp8": "Qwen 3.8 27B (India Deployed)",
};

const jarvisLabsPremiumModels = {
  "jarvislabs/glm-5.3": "GLM 5.3 (India Deployed)",
};

const jarvisLabsModels = {
  ...jarvisLabsBasicModels,
  ...jarvisLabsProModels,
  ...jarvisLabsPremiumModels,
};

const maskedModels = {
  "superdash-4.1-nano": "gpt-4.1-nano",
  "superdash-5-nano": "gpt-5-nano",
  "superdash-gpt4o-mini": "gpt-4o-mini",
  "superdash-4.1-mini": "gpt-4.1-mini",
  "superdash-5-mini": "gpt-5-mini",
  "superdash-5.4-mini": "gpt-5.4-mini",
  "superdash-5-chat": "gpt-5-chat-latest",
  "superdash-4.1": "gpt-4.1",
  "superdash-gpt-4o": "gpt-4o",
  "superdash-llama-4-maverick":
    "togetherai/meta-llama/Llama-4-Maverick-17B-128E-Instruct-FP8",
  "groq/meta-llama/llama-4-maverick-17b-128e-instruct":
    "superdash-llama-4-maverick",
  "superdash-llama-4-scout": "groq/meta-llama/llama-4-scout-17b-16e-instruct",
  "vertexai/gemini-2.0-flash": "gemini-2.0-flash",
  "vertexai/gemini-2.0-flash-lite": "gemini-2.0-flash-lite",
  "vertexai/gemini-2.5-flash": "gemini-2.5-flash",
  "vertexai/gemini-2.5-flash-lite": "gemini-2.5-flash-lite",
  "vertexai/gemini-2.5-pro": "gemini-2.5-pro",
  "vertexai/gemini-3-flash-preview": "gemini-3-flash-preview",
  "vertexai/gemini-3.1-flash-lite-preview": "gemini-3.1-flash-lite-preview"
};

// AWS Bedrock models offered to the assistant coach — the same Bedrock set as the main model
// dropdown (basic / pro / premium), so the coach can run on Bedrock too.
const bedrockCoachModels = Object.keys({ ...basicModels, ...proModels, ...premiumModels })
  .filter((model) => model.startsWith("bedrock/"))
  .reduce((acc, model) => {
    acc[model] = { ...basicModels, ...proModels, ...premiumModels }[model];
    return acc;
  }, {});

const reasoningModels = {
  // "gemini-2.0-flash": "Gemini 2.0 Flash",
  "gemini-2.5-flash": "Gemini 2.5 Flash",
  "gemini-2.5-flash-lite": "Gemini 2.5 Flash Lite",
  "gemini-3-flash-preview": "Gemini 3 Flash",
  "gpt-4.1-mini": "GPT 4.1 Mini",
  "gpt-5-mini": "GPT 5 Mini",
  "gpt-5-nano": "GPT 5 Nano",
  ...bedrockCoachModels,
};

const previewModels = {
  "gemini-3-flash-preview": true,
};

export {
  basicModels,
  proModels,
  premiumModels,
  oldModels,
  maskedModels,
  modelIcons,
  reasoningModels,
  previewModels,
  deprecatedModels,
  jarvisLabsBasicModels,
  jarvisLabsProModels,
  jarvisLabsPremiumModels,
  jarvisLabsModels
};
